export const ukEarTagRegex = /^uk ?([0-9]{6})[ ,/]?([0-9]{6})$/i;

export const updateEarTag = (userInputValue, existingAnimal) => {
  const animal = JSON.parse(JSON.stringify(existingAnimal));
  const matches = userInputValue.match(ukEarTagRegex);
  let tag = userInputValue;
  if (matches) {
    tag = `UK${matches[1]} ${matches[2]}`;
  }
  animal.tag = tag;
  return animal;
};

/**
 * Check if the ear tag validates against the BCMS
 * check digit system -
 * https://en.wikipedia.org/wiki/British_Cattle_Movement_Service#Check_digit
 *
 * @param {string} tag - the ear tag
 * @returns boolean - is the check digit correct
 */
export const validBCMSCheckDigit = tag => {
  const herdAndAnimalRegex = /^uk ?([0-9]{6})[ ,/]?([1-9])([0-9]{5})$/i;
  const matches = tag.match(herdAndAnimalRegex);
  if (!matches) return false;
  const herd = matches[1];
  const animal = matches[3];
  const checkDigit = parseInt(matches[2]);
  const num = parseInt(`${herd}${animal}`);
  const mod = num % 7;
  return (mod + 1) === checkDigit;
};

export const validateEarTag = tag => {
  const errors = {};
  if (!tag) {
    errors.tag = 'Required';
  } else if (typeof tag !== 'string' || tag.length < 3) {
    errors.tag = 'Must be a string at least 3 characters long';
  } else if (!tag.match(ukEarTagRegex)) {
    errors.tag = 'Must be a valid UK ear tag';
  } else if (!validBCMSCheckDigit(tag)) {
    errors.tag = 'BCMS check fails - invalid tag';
  }
  return errors;
};

export const fixCheck = tag => {
  const herdAndAnimalRegex = /^uk ?([0-9]{6})[ ,/]?([1-9])([0-9]{5})$/i;
  const matches = tag.match(herdAndAnimalRegex);
  if (!matches) return false;
  const herd = matches[1];
  const animal = matches[3];
  // const checkDigit = parseInt(matches[2]);
  const num = parseInt(`${herd}${animal}`);
  const mod = num % 7;
  const check = mod + 1;
  return `UK${herd} ${check}${animal}`;
};
